// extracted by mini-css-extract-plugin
export default {"top":"Q4xYn","leftPosition":"rdhAS","rightPosition":"LL85N","actions":"t5ebH","count":"b9VCe","wrapperLabels":"HSUJl","bottom":"EKTc5","selectedValues":"rj1bx","quizBtn":"E3lUN"};